import React, { useState, useEffect } from "react";
import Credin from "../../assets/Credin Logo (1).svg";
import { useNavigate } from "react-router-dom";

const translations = {
  ENGLISH: {
    officeBusiness: "Office / Business",
    select: "Select",
    office: "Office",
    business: "Business",
    officeBusinessDescription: "Office / Business Description",
    visitConducted: "Visit Conducted",
    yes: "Yes",
    no: "No",
    addressConfirmation: "Address Confirmation",
    ifAddressNotConfirmed: "If Address Not Confirmed",
    addressTrace: "Address Trace",
    easy: "Easy",
    notEasy: "Not Easy",
    landmark: "Landmark",
    metPersonName: "Met Person Name",
    metPersonDesignation: "Met Person Designation",
    applicantDesignation: "Applicant Designation",
    workingYears: "Working Years",
    salary: "Salary / Income",
    ownership: "Ownership",
    ownedByCompany: "Owned By Company",
    ownedByApplicant: "Owned By Applicant",
    rented: "Rented",
    employeeId: "Employee ID",
    seen: "Seen",
    notSeen: "Not Seen",
    high: "High",
    average: "Average",
    low: "Low",
    resiCumOffice: "Resi-Cum-Office",
    commercial: "Commercial",
    residence: "Residence",
    natureOfBusiness: "Nature Of Business",
    totalEmployee: "Total Employee",
    employeeSeen: "Employee Seen",
    officeSetup: "Office Setup",
    totalFloor: "Total Floor",
    applicantOfficeAt: "Applicant Office At",
    locality: "Locality",
    officeArea: "Office Area",
    area0to500: "0-500(sq.ft)",
    area500to1000: "500-1000(sq.ft)",
    area1000to2000: "1000-2000(sq.ft)",
    area2000Above: "2000(sq.ft) & Above",
    tpc1: "Tpc 1",
    tpcRemarks1: "Tpc Remarks 1",
    tpc2: "Tpc 2",
    tpcRemarks2: "Tpc Remarks 2",
    additionalRemarks: "Additional Remarks",
  },
  HINDI: {
    officeBusiness: "कार्यालय / व्यवसाय",
    select: "चुनें",
    office: "कार्यालय",
    business: "व्यवसाय",
    officeBusinessDescription: "कार्यालय / व्यवसाय का विवरण",
    visitConducted: "भेंट की गई",
    yes: "हाँ",
    no: "नहीं",
    addressConfirmation: "पते की पुष्टि",
    ifAddressNotConfirmed: "यदि पता पुष्टि नहीं हुई",
    addressTrace: "पते का पता",
    easy: "आसान",
    notEasy: "आसान नहीं",
    landmark: "सीमा चिन्ह",
    metPersonName: "मिले व्यक्ति का नाम",
    metPersonDesignation: "मिले व्यक्ति का पदनाम",
    applicantDesignation: "आवेदक का पदनाम",
    workingYears: "कार्य के वर्ष",
    salary: "वेतन / आय",
    ownership: "स्वामित्व",
    ownedByCompany: "कंपनी द्वारा स्वामित्व",
    ownedByApplicant: "आवेदक द्वारा स्वामित्व",
    rented: "किराए पर",
    employeeId: "कर्मचारी आईडी",
    seen: "देखा गया",
    notSeen: "नहीं देखा गया",
    high: "उच्च",
    average: "औसत",
    low: "निम्न",
    resiCumOffice: "आवास सह कार्यालय",
    commercial: "वाणिज्यिक",
    residence: "निवास",
    natureOfBusiness: "व्यवसाय की प्रकृति",
    totalEmployee: "कुल कर्मचारी",
    employeeSeen: "कर्मचारी देखा गया",
    officeSetup: "कार्यालय सेटअप",
    totalFloor: "कुल मंजिल",
    applicantOfficeAt: "आवेदक का कार्यालय",
    locality: "स्थान",
    officeArea: "कार्यालय क्षेत्र",
    area0to500: "0-500(वर्ग फुट)",
    area500to1000: "500-1000(वर्ग फुट)",
    area1000to2000: "1000-2000(वर्ग फुट)",
    area2000Above: "2000(वर्ग फुट) और ऊपर",
    tpc1: "टीपीसी 1",
    tpcRemarks1: "टीपीसी टिप्पणियाँ 1",
    tpc2: "टीपीसी 2",
    tpcRemarks2: "टीपीसी टिप्पणियाँ 2",
    additionalRemarks: "अतिरिक्त टिप्पणियाँ",
  },
  GUJARATI: {
    officeBusiness: "ઓફિસ / બિઝનેસ",
    select: "પસંદ કરો",
    office: "ઓફિસ",
    business: "બિઝનેસ",
    officeBusinessDescription: "ઓફિસ / બિઝનેસ વર્ણન",
    visitConducted: "મુલાકાત લીધી",
    yes: "હા",
    no: "ના",
    addressConfirmation: "સરનામાંની પુષ્ટિ",
    ifAddressNotConfirmed: "જો એડ્રેસ કન્ફર્મ નથી",
    addressTrace: "સરનામું મળ્યું",
    easy: "સરળ",
    notEasy: "સરળ નથી",
    landmark: "લેન્ડમાર્ક",
    metPersonName: "જે વ્યક્તિ ને મળ્યા એનું નામ",
    metPersonDesignation: "જે વ્યક્તિ ને મળ્યા એનો હોદ્દો",
    applicantDesignation: "borrower નો હોદ્દો",
    workingYears: "કામના વર્ષો",
    salary: "પગાર/આવક ",
    ownership: "માલિકી",
    ownedByCompany: "કંપની દ્વારા માલિકીની",
    ownedByApplicant: "અરજદાર દ્વારા માલિકીની",
    rented: "ભાડે",
    employeeId: "કર્મચારી ની ID",
    seen: "જુઓ",
    notSeen: "જુઓ નહી",
    high: "ઉચ્ચ",
    average: "સરેરાશ",
    low: "નમ્ર",
    resiCumOffice: "રેસિ-કમ-ઓફિસ",
    commercial: "વ્યાવસાયિક",
    residence: "નિવાસ",
    natureOfBusiness: "વ્યવસાય નો પ્રકાર",
    totalEmployee: "કુલ કર્મચારી",
    employeeSeen: "કર્મચારી જોયા",
    officeSetup: "ઓફિસ સેટઅપ",
    totalFloor: "કુલ માળ",
    applicantOfficeAt: "borrower ઓફિસ ",
    locality: "લોકાલિટી",
    officeArea: "ઓફિસ વિસ્તાર",
    area0to500: "0-500(ચોરસ ફુટ)",
    area500to1000: "500-1000(ચોરસ ફુટ)",
    area1000to2000: "1000-2000(ચોરસ ફુટ)",
    area2000Above: "2000(ચોરસ ફુટ) અને વધુ",
    tpc1: "Tpc 1",
    tpcRemarks1: "Tpc Remarks 1",
    tpc2: "Tpc 2",
    tpcRemarks2: "Tpc Remarks 2",
    additionalRemarks: "વધારાની ટિપ્પણીઓ",
  },
};

export default function Page3Office() {
  const navigate = useNavigate();
  const [cpvLanguage, setCpvLanguage] = useState("ENGLISH");

  useEffect(() => {
    const language = localStorage.getItem("cpvLanguage");
    console.log(language)
    setCpvLanguage(language);
  }, []);

  const [officeOrBusiness, setOfficeOrBusiness] = useState("");
  const [officeOrBusinessDescription, setOfficeOrBusinessDescription] = useState("");
  const [visitConducted, setVisitConducted] = useState("");
  const [addressConfirmation, setAddressConfirmation] = useState("");
  const [ifAddressNotConfirm, setIfAddressNotConfirm] = useState("");
  const [addressTrace, setAddressTrace] = useState("");
  const [landmark, setLandmark] = useState("");
  const [metPersonName, setMetPersonName] = useState("");
  const [metPersonDesignation, setMetPersonDesignation] = useState("");
  const [applicantDesignation, setApplicantDesignation] = useState("");
  const [workingYears, setWorkingYears] = useState("");
  const [salary, setSalary] = useState("");
  const [ownership, setOwnership] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [natureOfBusiness, setNatureOfBusiness] = useState("");
  const [totalEmployee, setTotalEmployee] = useState("");
  const [employeeSeen, setEmployeeSeen] = useState("");
  const [officeSetup, setOfficeSetup] = useState("");
  const [totalFloor, setTotalFloor] = useState("");
  const [applicantOfficeAt, setApplicantOfficeAt] = useState("");
  const [locality, setLocality] = useState("");
  const [officeArea, setOfficeArea] = useState("");
  const [tpc1, setTpc1] = useState("");
  const [tpcRemarks1, setTpcRemarks1] = useState("");
  const [tpc2, setTpc2] = useState("");
  const [tpcRemarks2, setTpcRemarks2] = useState("");
  const [additionalRemarks, setAdditionalRemarks] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem("OfficeOrBusinessCPV", officeOrBusiness);
    localStorage.setItem(
      "OfficeOrBusinessDescriptionCPV",
      officeOrBusinessDescription
    );
    localStorage.setItem("VisitConductedCPV", visitConducted);
    localStorage.setItem("AddressConfirmationCPV", addressConfirmation);
    localStorage.setItem("IfAddressNotConfirmCPV", ifAddressNotConfirm);
    localStorage.setItem("AddressTraceCPV", addressTrace);
    localStorage.setItem("LandmarkCPV", landmark);
    localStorage.setItem("MetPersonNameCPV", metPersonName);
    localStorage.setItem("MetPersonDesignationCPV", metPersonDesignation);
    localStorage.setItem("ApplicantDesignationCPV", applicantDesignation);
    localStorage.setItem("WorkingYearsCPV", workingYears);
    localStorage.setItem("SalaryCPV", salary);
    localStorage.setItem("OwnershipCPV", ownership);
    localStorage.setItem("EmployeeIdCPV", employeeId);
    localStorage.setItem("NatureOfBusinessCPV", natureOfBusiness);
    localStorage.setItem("TotalEmployeeCPV", totalEmployee);
    localStorage.setItem("EmployeeSeenCPV", employeeSeen);
    localStorage.setItem("OfficeSetupCPV", officeSetup);
    localStorage.setItem("TotalFloorCPV", totalFloor);
    localStorage.setItem("ApplicantOfficeAtCPV", applicantOfficeAt);
    localStorage.setItem("LocalityCPV", locality);
    localStorage.setItem("OfficeAreaCPV", officeArea);
    localStorage.setItem("Tpc1CPV", tpc1);
    localStorage.setItem("TpcRemarks1CPV", tpcRemarks1);
    localStorage.setItem("Tpc2CPV", tpc2);
    localStorage.setItem("TpcRemarks2CPV", tpcRemarks2);
    localStorage.setItem("AdditionalRemarksCPV", additionalRemarks);
    setTimeout(() => {
      navigate("/4");
    }, 2000);
  };

  return (
    <div className="main-login">
      <div style={{ margin: "2rem" }}>
        <img src={Credin} alt="Credin Logo" width="150" />
      </div>
      <div className="container-login">
        <div
          style={{
            fontWeight: "bolder",
            fontSize: "1.5rem",
            margin: ".5rem 0",
          }}
        >
          Interview Details
        </div>
        <form onSubmit={handleSubmit}>
          <div className="div-login">
            {/* <label>
              Office / Business <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].officeBusiness} <span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              required
              name="office-business"
              value={officeOrBusiness}
              onChange={(e) => setOfficeOrBusiness(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="Office">{translations[cpvLanguage].office}</option>
              <option value="Business">{translations[cpvLanguage].business}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Office / Business Description{" "}
              <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].officeBusinessDescription} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              required
              name="office-business-description"
              value={officeOrBusinessDescription}
              onChange={(e) => setOfficeOrBusinessDescription(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Visit Conducted <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].visitConducted} <span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              required
              name="visit-conducted"
              value={visitConducted}
              onChange={(e) => setVisitConducted(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="Yes">{translations[cpvLanguage].yes}</option>
              <option value="No">{translations[cpvLanguage].no}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Address Confirmation <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].addressConfirmation} <span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="address-confirmation"
              value={addressConfirmation}
              onChange={(e) => setAddressConfirmation(e.target.value)}
              required
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="Yes">{translations[cpvLanguage].yes}</option>
              <option value="No">{translations[cpvLanguage].no}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              If Address Not Confirmed <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].ifAddressNotConfirmed} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="if-address-not-confirmed"
              value={ifAddressNotConfirm}
              onChange={(e) => setIfAddressNotConfirm(e.target.value)}
              required
            />
          </div>
          <div className="div-login">
            {/* <label>
              Address Trace <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].addressTrace} <span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="address-trace"
              value={addressTrace}
              onChange={(e) => setAddressTrace(e.target.value)}
              required
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="Easy">{translations[cpvLanguage].easy}</option>
              <option value="Not Easy">{translations[cpvLanguage].notEasy}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Landmark <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].landmark} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="landmark"
              value={landmark}
              onChange={(e) => setLandmark(e.target.value)}
              required
            />
          </div>
          <div className="div-login">
            {/* <label>
              Met Person Name <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].metPersonName} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="met-person-name"
              required
              value={metPersonName}
              onChange={(e) => setMetPersonName(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Met Person Designation <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].metPersonDesignation}<span style={{ color: "red" }}>*</span> </label>
            <input
              type="text"
              name="met-person-designation"
              required
              value={metPersonDesignation}
              onChange={(e) => setMetPersonDesignation(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Applicant Designation <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].applicantDesignation}<span style={{ color: "red" }}>*</span> </label>
            <input
              type="text"
              name="applicant-designation"
              required
              value={applicantDesignation}
              onChange={(e) => setApplicantDesignation(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Working Years <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].workingYears}<span style={{ color: "red" }}>*</span> </label>
            <input
              type="text"
              name="working-years"
              value={workingYears}
              required
              onChange={(e) => setWorkingYears(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Salary / Income <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].salary}<span style={{ color: "red" }}>*</span> </label>
            <input
              type="text"
              name="salary"
              required
              value={salary}
              onChange={(e) => setSalary(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Ownership <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].ownership} <span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="ownership"
              required
              value={ownership}
              onChange={(e) => setOwnership(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="Owned By Company">{translations[cpvLanguage].ownedByCompany}</option>
              <option value="Owned By Applicant">{translations[cpvLanguage].ownedByApplicant}</option>
              <option value="Rented">{translations[cpvLanguage].rented}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Employee ID <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].employeeId} <span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="employee-id"
              value={employeeId}
              required
              onChange={(e) => setEmployeeId(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="Seen">{translations[cpvLanguage].seen}</option>
              <option value="Not Seen">{translations[cpvLanguage].notSeen}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Nature Of Business <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].natureOfBusiness} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="nature-of-business"
              required
              value={natureOfBusiness}
              onChange={(e) => setNatureOfBusiness(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Total Employee <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].totalEmployee}<span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="total-employee"
              required
              value={totalEmployee}
              onChange={(e) => setTotalEmployee(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Employee Seen <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].employeeSeen}<span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="employee-seen"
              required
              value={employeeSeen}
              onChange={(e) => setEmployeeSeen(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="Yes">{translations[cpvLanguage].yes}</option>
              <option value="No">{translations[cpvLanguage].no}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Office Setup <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].officeSetup}<span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              value={officeSetup}
              required
              name="office-setup"
              onChange={(e) => setOfficeSetup(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="High">{translations[cpvLanguage].high}</option>
              <option value="Average">{translations[cpvLanguage].average}</option>
              <option value="Low">{translations[cpvLanguage].low}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Total Floor <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].totalFloor}<span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="total-floor"
              required
              value={totalFloor}
              onChange={(e) => setTotalFloor(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Applicant Office At <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].applicantOfficeAt}<span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              value={applicantOfficeAt}
              required
              name="applicant-office-at"
              onChange={(e) => setApplicantOfficeAt(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Locality <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].locality}<span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              value={locality}
              name="locality"
              required
              onChange={(e) => setLocality(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="Resi-Cum-Office">{translations[cpvLanguage].resiCumOffice}</option>
              <option value="Commercial">{translations[cpvLanguage].commercial}</option>
              <option value="Residence">{translations[cpvLanguage].residence}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Office Area <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].officeArea}<span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="office-area"
              required
              value={officeArea}
              onChange={(e) => setOfficeArea(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="0-500(sq.ft)">{translations[cpvLanguage].area0to500}</option>
              <option value="500-1000(sq.ft)">{translations[cpvLanguage].area500to1000}</option>
              <option value="1000-2000(sq.ft)">{translations[cpvLanguage].area1000to2000}</option>
              <option value="2000(sq.ft) & Above">{translations[cpvLanguage].area2000Above}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Tpc 1 <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].tpc1}<span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="tpc-1"
              required
              value={tpc1}
              onChange={(e) => setTpc1(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Tpc Remarks 1 <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].tpcRemarks1}<span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="tpc-remarks-1"
              required
              value={tpcRemarks1}
              onChange={(e) => setTpcRemarks1(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Tpc 2 <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].tpc2}<span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="tpc-2"
              required
              value={tpc2}
              onChange={(e) => setTpc2(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Tpc Remarks 2 <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].tpcRemarks2}<span style={{ color: "red" }}>*</span></label>

            <input
              type="text"
              name="tpc-remarks-2"
              required
              value={tpcRemarks2}
              onChange={(e) => setTpcRemarks2(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Additional Remarks <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].additionalRemarks}<span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="additional-remarks"
              required
              value={additionalRemarks}
              onChange={(e) => setAdditionalRemarks(e.target.value)}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: ".5rem",
            }}
          >
            <button className="btn-login" type="submit">
              Proceed
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
